export default {
    EM_ABERTO: 1,
    EM_ATENDIMENTO: 2,
    FINALIZADO: 3,
    REABERTO: 4,
    CANCELADO: 5,
}